<template lang="pug">
div
  label.btn.btn-action.btn-link(
    for="files"
    :class="{disabled: uploading}"
  )
    i.fa.fa-paperclip
    |  Anexar arquivo
  input#files.input-files(type="file" ref="inputFile" @change="onChangeFiles" accept="image/*,application/pdf" )  
  div(v-if="thumbs.length")
    .divider
    h1.h5 Fila de upload
    .upload-list
      .bg-gray.s-rounded.my-2.py-2(v-for="thumb, index in thumbs")
        .columns
          .column.col-auto
            img.image.s-rounded.img-responsive(:src="thumb")
          .column.text-ellipsis
            .text-ellipsis {{ files[index].name }}
            div.text-gray {{ files[index].size / 1000 | currency('', ' kb') }}
            progress.progress(:value="progress" max="100" v-if="currentIndex == index && !done")
            .text-error(v-else-if="errors[index]") {{ errors[index].message }}
          .column.col-auto.flex-centered.mr-2
            i.fa.fa-2x.fa-exclamation-circle.text-error(v-if="errors[index]")
            i.fa.fa-2x.fa-check-circle.text-primary(v-else-if="done || currentIndex > index")
            .text-large(v-else-if="currentIndex == index") {{ progress }}%
</template>

<script>
import Anexo from "@/models/Anexo"
import { sanitize } from "paliari-js-utils"

const fileSinitizeRule = {
  id: true,
  url: true,
  thumb: true,
  name: true,
  size: true,
  uri_token: true,
  ext: true,
}

export default {
  vuex: {
    uploads: {
      actions: ["fetchUploadMultiple"],
      state: [
        "uploading",
        "files",
        "currentIndex",
        "progress",
        "done",
        "errors",
      ],
      mutations: ["setFiles", "resetState"],
    },
  },
  props: { value: { type: Object } },
  data() {
    return { thumbs: [] }
  },
  watch: {
    files() {
      this.thumbs = []
      if (this.files && Object.keys(this.files).length > 0) {
        for (const file of this.files) {
          const reader = new FileReader()
          reader.onload = e =>
            this.thumbs.push(
              file.type === "application/pdf"
                ? "/img/pdf_icon.png"
                : e.target.result,
            )
          reader.readAsDataURL(file)
        }
      }
    },
  },
  methods: {
    async onChangeFiles({ target: { files } }) {
      this.resetState()
      this.setFiles(files)
      const uploaded = await this.fetchUploadMultiple({ files })
      const file = uploaded[0] || {}
      const anexo = new Anexo({
        url: file.url,
        thumb: file.thumb,
        file_info: sanitize(file, fileSinitizeRule),
      })
      this.$emit("input", anexo)
      this.$refs.inputFile.value = null
    },
  },
}
</script>

<style lang="stylus" scoped>
.input-files
  position absolute
  left -100vw
  opacity 0

.image
  max-width 80px

.progress
  max-width 50%

.upload-list
  max-height 300px
  overflow-y auto
  overflow-x hidden
</style>
